import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppUtilityService } from '../../../core/services/app-utility.service';


@Component({
  selector: 'lms-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SpinnerComponent),
    multi: true
  }]
})

export class SpinnerComponent implements ControlValueAccessor, OnInit, OnDestroy {
  error = '';
  @Input() minValue;
  @Input() maxValue;
  @Input() size;
  @Input() inputId;
  @Input() showError;
  @Input() disabledValue;
  @Input() tabindex: number;
  keyPattern: RegExp = /[0-9\+\-]/;
  inputWidth = 60;
  public timer: any;

  @Input() _value;
  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }


  constructor(private appUtilityService: AppUtilityService) { }
  ngOnInit() {
  }

  ngOnDestroy() {
    this.clearTimer();
  }
  /**
   * this method is user to increase
   *  the value by one
   * @memberof SpinnerComponent
   */
  increaseValue() {
    if (this.value === '' || this.value === '-') {
      this.value = this.minValue;
    } else {
      if (this.value < this.maxValue) {
        this.value = parseInt(this.value, 10) + 1;
      }
    }
    this.error = '';
  }

  /**
   * this method is user to decrease
   *  the value by one
   * @memberof SpinnerComponent
   */
  decreaseValue() {
    if (this.value === '' || this.value === '-') {
      this.value = this.minValue;
    } else {
      if (this.value > this.minValue) {
        this.value = parseInt(this.value, 10) - 1;
      }
    }
    this.error = '';
  }


  /**
   * when input value change
   * then this method trigger and we apply validation
   * @param {any} evt
   * @returns
   * @memberof SpinnerComponent
   */
  changeInputValue(evt) {
    if (evt.currentTarget.value) {
      const charCode = (evt.which) ? evt.which : evt.keyCode;

      if (charCode === 45) {
        return false;
      }
    }
    return this.appUtilityService.isNegativePositiveNumber(evt);
  }

  /**
   * apply validation on input value
   * @param {any} evt
   * @memberof SpinnerComponent
   */
  validateValue(evt) {
    this.value = evt.currentTarget.value;
    if (this.value === '' || this.value === '-' || this.value < this.minValue || this.value > this.maxValue) {
      this.error = 'Please enter valid value between ' + this.minValue + ' to ' + this.maxValue;
    } else {
      this.error = '';
    }
  }

  onInputKeydown(event: KeyboardEvent) {
    if (event.which === 38) {
      this.spin(1);
      event.preventDefault();
    } else if (event.which === 40) {
      this.spin(0);
      event.preventDefault();
    }
  }

  onInputUp(event: Event, inputValue: string) {
    // this.changeInputValue(event);
    this.value = inputValue;
  }

  /**
   * when long time mouse click press
   * then set interval to continue
   * increse value or decrease
   * @param {number} interval
   * @param {number} dir
   * @memberof SpinnerComponent
   */
  repeat(interval: number, dir: number) {
    const i = interval || 500;
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.repeat(40, dir);
    }, i);

    this.spin(dir);
  }

  /**
   * by this we decide
   * if dir is 1 then increase value
   * else decrease vale
   * @param {number} dir
   * @memberof SpinnerComponent
   */
  spin(dir: number) {
    if (dir) {
      this.increaseValue();
    } else {
      this.decreaseValue();
    }
  }

  /**
   * clear timer which we set on
   * long click on button
   * @memberof SpinnerComponent
   */
  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  /**
   * work on  up button at mouse down time
   * @param {Event} event
   * @param {HTMLInputElement} input
   * @memberof SpinnerComponent
   */
  onUpButtonMousedown(event: Event, input: HTMLInputElement) {
    if (!this.disabledValue) {
      input.blur();
      this.repeat(null, 1);
    }
  }

  /**
   * work on  up button at mouse up time
   * @param {Event} event
   * @memberof SpinnerComponent
   */
  onUpButtonMouseup(event: Event) {
    if (!this.disabledValue) {
      this.clearTimer();
    }
  }

  /**
   * work on  up button at mouse leave time
   * @param {Event} event
   * @memberof SpinnerComponent
   */
  onUpButtonMouseleave(event: Event) {
    if (!this.disabledValue) {
      this.clearTimer();
    }
  }

  /**
   * work on  down button at mouse down time
   * @param {Event} event
   * @param {HTMLInputElement} input
   * @memberof SpinnerComponent
   */
  onDownButtonMousedown(event: Event, input: HTMLInputElement) {
    if (!this.disabledValue) {
      input.blur();
      this.repeat(null, 0);
    }
  }

  /**
   * work on  down button at mouse up time
   * @param {Event} event
   * @memberof SpinnerComponent
   */
  onDownButtonMouseup(event: Event) {
    if (!this.disabledValue) {
      this.clearTimer();
    }
  }

  /**
     * work on  down button at mouse leave time
     * @param {Event} event
     * @memberof SpinnerComponent
     */
  onDownButtonMouseleave(event: Event) {
    if (!this.disabledValue) {
      this.clearTimer();
    }
  }


  // From ControlValueAccessor interface
  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
